import SignInPageLayout from './SignInPageLayout';

export default SignInPageLayout;
